import PregnancyWeekByWeekView from './pregnancy-week-by-week-view'

export default PregnancyWeekByWeekView
